/** Route paths — keep Estore navigation self-contained (do not use /ShopPage etc.). */

export const ESTORE_ROUTES = {
  home: "/Estore",
  shop: "/EstoreShop",
  product: "/EstoreProduct",
  cart: "/EstoreCart",
  checkout: "/EstoreCheckout",
  account: "/EstoreAccount",
};

export function estoreProductUrl(id) {
  return `${ESTORE_ROUTES.product}?id=${encodeURIComponent(String(id))}`;
}

export function estoreShopUrl(search) {
  if (!search) return ESTORE_ROUTES.shop;
  return `${ESTORE_ROUTES.shop}?search=${encodeURIComponent(search)}`;
}
